import posthog from 'posthog-js';

/**
 * Log an error to the console and PostHog.
 *
 * @param {unknown} error
 * @param {string} [tag]
 * @param {Record<string, unknown>} [context]
 */
export const logError = (error, tag = 'no_tag', context = {}) => {
	const errorId = crypto.randomUUID?.() || 'unknown';
	console.error(`[${tag}] Error ID: ${errorId}`, error, context);

	try {
		if (posthog?.capture) {
			posthog.capture('log_error', {
				errorId,
				tag,
				message: error?.message || String(error),
				...context
			});
		}
	} catch (err) {
		// ensure logging never throws
		console.error('PostHog capture failed', err);
	}
};
